<section class="about-section" id="about">
  <div class="container">
    <!-- Header -->
    <div class="text-center mb-5">
      <span class="badge-tag">{{ 'about.small_title' | translate }}</span>
      <h2 class="section-title mt-3">
        <span>{{ 'about.title_1' | translate }}</span>
        <span class="text-highlight">{{ 'about.title_2' | translate }}</span>
      </h2>
      <div class="section-divider mx-auto mt-3"></div>
    </div>

    <!-- Main 2-Column Content Row -->
    <div class="row align-items-center justify-content-between g-5">
      <!-- Left Column: Story & Overview -->
      <div class="col-12 col-lg-6">
        <div class="about-content">
          <p class="lead-text mb-3">
            {{ 'about.lead_text' | translate }}
          </p>
          <p class="secondary-text mb-4">
            {{ 'about.desc' | translate }}
          </p>

          <!-- Key Highlights / Bullets -->
          <div class="about-bullets mb-4">
            @for (bullet of highlights; track bullet) {
              <div class="bullet-item d-flex align-items-center mb-3">
                <div class="bullet-icon-box me-3">
                  <svg-icon src="/assets/images/svg-icons/phase-complete.svg"></svg-icon>
                </div>
                <span class="bullet-text">{{ bullet | translate }}</span>
              </div>
            }
          </div>

          <!-- CTAs -->
          <div class="d-flex flex-wrap gap-3 mt-4 pt-2">
            <a href="/assets/documents/ICO_Whitepaper.pdf" target="_blank" class="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2">
              <img src="/assets/images/svg-icons/whitepaper-icon.svg" alt="Whitepaper" loading="lazy" />
              <span>{{ 'about.btn_whitepaper' | translate }}</span>
            </a>
            <a href="/assets/documents/ICO_Audit.pdf" target="_blank" class="btn btn-secondary d-inline-flex align-items-center gap-2 px-4 py-2">
              <img src="/assets/images/svg-icons/audit-icon.svg" alt="Audit" loading="lazy" />
              <span>{{ 'about.btn_audit' | translate }}</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Right Column: Visual Showcase -->
      <div class="col-12 col-lg-5">
        <div class="about-visual position-relative mx-auto">
          <div class="glow-orb"></div>
          <div class="visual-card">
            <img src="/assets/images/png/about-illustration.png" alt="About $TALC" class="img-fluid about-img" loading="lazy" />
          </div>
        </div>
      </div>
    </div>

    <!-- Feature Pillars Cards Row -->
    <div class="row g-4 mt-4 pt-3">
      @for (feature of features; track feature.title) {
        <div class="col-12 col-md-4">
          <div class="feature-card h-100">
            <div class="feature-icon-wrapper mb-3">
              <img [src]="feature.icon" [alt]="feature.title | translate" class="feature-icon" loading="lazy" />
            </div>
            <h4 class="feature-title mb-2">{{ feature.title | translate }}</h4>
            <p class="feature-desc mb-0">{{ feature.desc | translate }}</p>
          </div>
        </div>
      }
    </div>

    <!-- Stats Bar -->
    <div class="stats-bar mt-5">
      <div class="row g-4 text-center">
        @for (stat of stats; track stat.label) {
          <div class="col-6 col-md-3">
            <div class="stat-item">
              <h3 class="stat-value font-36 fw-bold mb-1">{{ stat.value | translate }}</h3>
              <p class="stat-label font-14 mb-0">{{ stat.label | translate }}</p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>